import { render, staticRenderFns } from "./DeliveryOrderDetailUploadFromDetail.vue?vue&type=template&id=6336e07c&"
import script from "./DeliveryOrderDetailUploadFromDetail.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderDetailUploadFromDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports